<template>
    <div class="menu-tree">
        <ul>
            <li
                v-for="item in newsTypeList"
                :key="item.typeId"
                :class="{ 'cur': curNewsTypeData.typeId === item.typeId}"
            >
                <span :title="item.typeName" @click="toggleNewsTypeData(item)">
                    {{item.typeName}}
                </span>
            </li>
        </ul>
    </div>
</template>

<script>
import Api from '@/api/index.js';
import animateScrollTo from 'animated-scroll-to';

export default {
    name: "MenuTree",
    props: {
        newsTypeData: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            newsTypeList: [],
            curNewsTypeData: {}
        };
    },
    watch: {
        '$i18n.locale'() {
            this.init();
        }
    },
    created() {
        this.init();
    },
    methods: {
        init() {
            this.curNewsTypeData = this.newsTypeData;
            Api.getNewsTypeList({
                lang: this.$i18n.locale,
                homeFlag: false
            }).then(res => {
                if (res.data.newsTypeVos) {
                    this.newsTypeList = res.data.newsTypeVos.map(item => {
                        return {
                            typeId: item.typeId,
                            typeName: item.typeName,
                            typeCode: item.typeCode
                        };
                    });
                }
            });
        },
        toggleNewsTypeData(data) {
            this.curNewsTypeData = data;
            this.$store.commit('setNewsTypeData', data);
            this.$router.push({
                name: 'news'
            });
            animateScrollTo(0);
        }
    }
};
</script>
<style lang="less" scoped>
.menu-tree {
    width: 100%;
    ul {
        &.sticky {
            position: sticky;
            top: 100px;
            z-index: 99;
        }
        li {
            font-size: 20px;
            line-height: 36px;
            font-weight: 200;
            cursor: pointer;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            padding: 8px 40px 8px 60px;
            &.cur {
                background: url('@/assets/news-cur.png') left center no-repeat;
                color: #4C84FF;
                font-weight: 500;
                cursor: default;
            }
        }
    }
}
</style>
